export const defaultMessages = {
    ERR_NETWORK: 'Unable to connect to the server. Please try again later.',
    404: 'Request URL Not found.',
    422: 'Invalid input. Please check and try again.',
    500: 'Internal Server error. Try again later.',
    401: 'Session expired. Please login again.',
    403: 'You are not authorized to perform this action.',
}

export const roleToPath = {
    "Admin": "/admin/dashboard",
    "Sales Executive": "/sales-executive/dashboard",
    "Warehouse Manager": "/warehouse-manager/dashboard",
    "Purchase Head": "/purchase-head/dashboard",
    "Farm Purchase Manager": "/farm-purchase-manager/dashboard",
    "Farm Supervisor": "/farm-supervisor/dashboard",
    "Receiving Manager": "/receiving-manager/dashboard",
    "QC Manager": "/qc-manager/dashboard",
    "QC Executive": "/qc-executive/dashboard",
    "Production Manager": "/production-manager/dashboard",
    "Packaging Supervisor": "/packaging-supervisor/dashboard",
    "Dispatch Executive": "/dispatch-executive/dashboard",
    "Factory Purchase Manager": "/factory-purchase-manager/dashboard",
    "Gate Keeper": "/gate-keeper/dashboard",
};

// Sales Order Form Options
// export const PROCESS_TYPE_OPTIONS = [
//     { value: 'Head On', label: 'Head On' },
//     { value: 'Headless', label: 'Headless' },
//     { value: 'Easy Peel', label: 'Easy Peel' },
//     { value: 'PUD', label: 'PUD' },
//     { value: 'PDTO', label: 'PDTO' }
// ];

export const FREEZING_METHOD_OPTIONS = [
    { value: 'Brine', label: 'Brine' },
    { value: 'Blast', label: 'Blast' },
    { value: 'IQF', label: 'IQF' },
    { value: 'Plate', label: 'Plate' },
    { value: 'Block Frozen', label: 'Block Frozen' },
];

export const FREEZING_PERCENTAGE_OPTIONS = [
    { value: '10', label: '10' },
    { value: '20', label: '20' },
    { value: '30', label: '30' }
];

// Sales Order Form Additional Options
export const PRIORITY_OPTIONS = [
    { value: 'Urgent', label: 'Urgent' },
    { value: 'High', label: 'High' },
    { value: 'Normal', label: 'Normal' },
    //{ value: 'Low', label: 'Low' }
];

// Order Status and Priority Style Constants
export const STATUS_STYLES = {
    'Pending': 'bg-grayClr',
    'In Progress': 'bg-secondaryDisableClr',
    'Processing': 'bg-blue-500',
    'Completed': 'bg-pastelGreenClr',
    'Cancelled': 'bg-red-500'
};

export const PRIORITY_STYLES = {
    'Normal': 'text-primaryDefaultClr',
    'Urgent': 'text-errorDefaultClr',
    'High': 'text-secondaryDefaultClr',
    'Medium': 'text-yellow-600',
    'Low': 'text-gray-600',
    'Partial Shipment': 'text-brightBlueClr'
};

export const PRIORITY_BULLET_COLORS = {
    'Normal': 'bg-primaryDefaultClr',
    'Urgent': 'bg-errorDefaultClr',
    'High': 'bg-secondaryDefaultClr',
    'Medium': 'bg-yellow-600',
    'Low': 'bg-gray-600',
    'Partial Shipment': 'bg-brightBlueClr'
};

// Vehicle Fuel Type Options
export const FUEL_TYPE_OPTIONS = [
    { label: "Petrol", value: "Petrol" },
    { label: "Diesel", value: "Diesel" },
    { label: "CNG", value: "CNG" },
    { label: "Electric", value: "Electric" }
];

export const COUNTRY_OPTIONS = [
    { value: 'india', label: 'India' },
    { value: 'usa', label: 'United States' },
    { value: 'uk', label: 'United Kingdom' },
    { value: 'canada', label: 'Canada' },
    { value: 'australia', label: 'Australia' }
];

export const ORDER_ITEM_OPTIONS = [
    { value: 'shrimp', label: 'Shrimp' },
    { value: 'fish', label: 'Fish' },
    { value: 'crab', label: 'Crab' }
];

export const SPECIES_OPTIONS = [
    { value: 'black_tiger', label: 'Black Tiger' },
    { value: 'white_shrimp', label: 'White Shrimp' },
    { value: 'king_prawn', label: 'King Prawn' }
];

export const GRADE_OPTIONS = [
    { value: '15', label: '15' },
    { value: '20', label: '20' },
    { value: '25', label: '25' },
    { value: '30', label: '30' }
];

// Default form values
export const DEFAULT_CUSTOMER_VALUES = {
    customerName: '',
    customerCompany: '',
    mobileNumber: '',
    email: '',
    location: '',
    orderPriority: '',
    deadlineDate: '',
    countryOfOrigin: '',
    countryOfDestination: ''
};

export const DEFAULT_ORDER_VALUES = {
    itemId: "",
    species: "",
    processType: "",
    ratePerKg: "",
    freezingMethod: "",
    freezingPercentage: "",
    weightPerPouch: "",
    weightPerCarton: "",
    totalPouches: "",
    totalCartons: "",

    gradesDetails: [
        {
            gradeId: "",
            quantity: "",
            ratePerKg: ""
        }
    ],

};

export const RESET_ORDER_FIELDS = {
    itemId: '',
    itemName: '',
    itemImage: '',
    species: '',
    processType: '',
    freezingMethod: '',
    freezingPercentage: '',
    ratePerKg: '',
    gradesDetails: [
        {
            gradeId: '',
            grade: '',
            quantity: '',
            ratePerKg: ''
        }
    ],
    weightPerPouch: '',
    weightPerCarton: '',
    totalPouches: '',
    totalCartons: '',
};

// Order status options for filtering
export const ORDER_STATUS_OPTIONS = [
    // { value: 'All', label: 'All Status' },
    { value: 'Pending', label: 'Pending' },
    { value: 'Dispatched', label: 'Dispatched' },
    { value: 'Completed', label: 'Completed' },
];

// Order status colors mapping
export const ORDER_STATUS_COLORS = {
    Pending: 'secondaryDefaultClr',
    Dispatched: 'disableTextClr',
    Completed: 'primaryDefaultClr',
    default: 'defaultTextClr'
};

// Order progress colors mapping
export const ORDER_PROGRESS_COLORS = {
    high: 'bg-green-500',    // >= 70%
    medium: 'bg-yellow-500', // >= 40%
    low: 'bg-red-500'        // < 40%
};

export const AUXILIARY_REQUEST_STATUS_COLORS = {
    'Pending': '#F7BC43',
    'Approved': '#22984E',
    'Rejected': '#F12727',
    'Partially Completed': '#4F46E5'
};

export const DASHBOARD_FILTER_OPTIONS = [
    { "label": "Yearly", "value": "yearly" },
    { "label": "Monthly", "value": "monthly" },
    { "label": "Weekly", "value": "weekly" },
]

// Factory Purchase Manager - Auxiliary Items Constants
export const AUXILIARY_ITEM_CATEGORIES = [
    { value: 'Packaging', label: 'Packaging' },
    { value: 'Storage', label: 'Storage' },
    { value: 'Equipment', label: 'Equipment' },
    { value: 'Tools', label: 'Tools' },
    { value: 'Safety', label: 'Safety' },
    { value: 'Other', label: 'Other' }
];

export const UNIT_OF_MEASUREMENT_OPTIONS = [
    { value: 'Piece', label: 'Piece' },
    { value: 'Kg', label: 'Kg' },
    { value: 'Liter', label: 'Liter' },
    { value: 'Meter', label: 'Meter' },
    { value: 'Box', label: 'Box' },
    { value: 'Set', label: 'Set' }
];

export const STORAGE_LOCATION_OPTIONS = [
    { value: 'Warehouse A', label: 'Warehouse A' },
    { value: 'Warehouse B', label: 'Warehouse B' },
    { value: 'Warehouse C', label: 'Warehouse C' },
    { value: 'Cold Storage', label: 'Cold Storage' }
];

export const STORAGE_CONDITIONS_OPTIONS = [
    { value: 'Room Temperature', label: 'Room Temperature' },
    { value: 'Cold Storage', label: 'Cold Storage' },
    { value: 'Freezer', label: 'Freezer' },
    { value: 'Dry Area', label: 'Dry Area' }
];

export const PAYMENT_MODE_OPTIONS = [
    { value: 'Cash', label: 'Cash' },
    { value: 'Credit', label: 'Credit' },
    { value: 'Cheque', label: 'Cheque' },
    { value: 'Online Transfer', label: 'Online Transfer' }
];

export const PAYMENT_STATUS_OPTIONS = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Paid', label: 'Paid' },
    { value: 'Partial', label: 'Partial' }
];

export const QUALITY_STATUS_OPTIONS = [
    { value: 'Approved', label: 'Approved' },
    { value: 'Rejected', label: 'Rejected' },
    { value: 'Pending', label: 'Pending' }
];

export const STOCK_STATUS_COLORS = {
    'Normal': 'bg-green-500',
    'Low': 'bg-yellow-500',
    'Critical': 'bg-red-500',
    'Out of Stock': 'bg-gray-500'
};

export const STOCK_STATUS_TEXT_COLORS = {
    'Normal': 'text-green-600',
    'Low': 'text-yellow-600',
    'Critical': 'text-red-600',
    'Out of Stock': 'text-gray-600'
};